import { css } from "@emotion/css";
import { PropsWithChildren } from "react";

import { Text } from "../../foundations/typography/Text";
import { useColors } from "../../hooks/useColors";
import { ScrollContainer } from "../../internal/scroll-container/ScrollContainer";

export interface LegalProps {
  testID?: string;
  expanded?: boolean;
}

export const LEGAL_MAX_HEIGHT = 184;

export function Legal(props: PropsWithChildren<LegalProps>) {
  const { children, testID = "legal", expanded = false } = props;
  const colors = useColors();

  return (
    <div
      className={css({
        position: "relative",
        backgroundColor: "var(--background-accent-neutral-weak)",
        borderRadius: "var(--border-radius-2)",
        overflow: "hidden",
        border: `1px solid ${colors["border-base"]}`,
      })}
      data-testid={testID}
    >
      <ScrollContainer
        background="background-input-disabled"
        maxHeight={expanded ? "none" : `${LEGAL_MAX_HEIGHT}px`}
        padding="space-4"
      >
        <Text style="summary/legal-primary" color="text-base">
          {children}
        </Text>
      </ScrollContainer>
    </div>
  );
}
